import storage from "../../../utils/storage";
import { initialAuthState, actions } from "./action";

export const authReducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actions.AUTH_CREATE_SUCCESS:

        if(action?.payload?.msgcode){
            storage.set('isLoggedIn', false)
            return {...state}
        }else{
            storage.setToken(action.payload.token)
            //storage.set(action.payload.user)
            storage.set('userName', action?.payload?.user?.firstName + ' ' + action?.payload?.user?.lastName );
            storage.set('loginUser', action?.payload?.user)
            storage.set('isLoggedIn', true);
            
            return {
                ...state,
                fetching: false,
                error: undefined,
                userName: action?.payload?.user?.firstName + ' ' + action?.payload?.user?.lastName,
                authToken: action.payload.token,
                user: action?.payload?.user,
                isLoggedIn: true
            };
        }
        case actions.AUTH_CREATE_FAILURE: 
            return {
                ...state,
                error: action.payload
            }
        case actions.USER_GET_ALL_SUCCESS: 
            return {
                ...state,
                user: Array.isArray(action.payload) ? action.payload[0] : {}
            }
        default:
            return state;
    }
};